const resources = {
  colors: {
    dr_light_blue: "#00ADEE",
    dr_dark_blue: "#1A76BC",
    light_gray: "#EEE",
  },
};

export default resources;
